import React, {useState} from 'react';
import styles from './VolumeCommand.module.css';
import Loader from '../../../assets/Animations/PreLoaderComponent/Loader';
import ChangeMonthCalendar from '../../MediaAndNews/ChangeMonthCalendar';

const capitalize = (value: string) =>
	value ? value.charAt(0).toUpperCase() + value.slice(1) : value;

type Props = {
	isFetchingVolumeCommand: boolean;
	currentMonthName: string;
	setCurrentMonthName: (name: string) => void;
	handleSetMonth: (value: string) => void;
};

const MonthChangeButton: React.FC<Props> = ({
	isFetchingVolumeCommand,
	currentMonthName,
	setCurrentMonthName,
	handleSetMonth,
}) => {
	const [showCalendar, setShowCalendar] = useState(false);

	return (
		<div className={styles.dataChartForm}>
			<div className={styles.formChart}>
				<div className={styles.calendarWrapper}>
					{isFetchingVolumeCommand ? (
						<div className={styles.loaderContainer}>
							<Loader size="small" color="#7a934f" />
						</div>
					) : (
						<button
							onClick={() => setShowCalendar((prev) => !prev)}
							name="month"
							className={styles.formChartSelect}
						>
							{currentMonthName}
						</button>
					)}
					{showCalendar && (
						<div className={styles.calendarPopover}>
							<ChangeMonthCalendar
								setCurrentMonthName={(label) =>
									setCurrentMonthName(capitalize(label))
								}
								close={setShowCalendar}
								setCurrentMonth={handleSetMonth}
								wrapperClassName={styles.dataChartCalendarContainer}
								calendarClassName={styles.calendarEmbedded}
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default MonthChangeButton;
